import { cloneDeep } from "lodash";

const subtitles = [
  "Find the best version of anything.",
  "Stop guessing, start improving.",
  "The smart way to find what works best.",
];

const introduction = [
  {
    type: "text/main_title_subtitle",

    verticalAlign: "center",
    horizontalAlign: "center",

    titles: ["Mix Max"],
    subtitles,
    textStyle: {
      textAlign: "center",
    },
  },
];

const introduction_showcase = [
  {
    type: "screenshot/showcase_double_pivot",

    screenshots: [
      {
        src: "mix-max/assets/screnshots/parameter_list.png",
        alt: "Screenshot of an experiment with its parameters",
      },
      {
        src: "mix-max/assets/screnshots/outcomes_list.png",
        alt: "Screenshot of an experiment's outcomes and their priorities",
      },
    ],
  },
];

const main_feature_descriptions = [
  {
    type: "layout/split_horizontal",
    contentLeft: [
      {
        type: "screenshot/single_enlarged",

        horizontalAlign: "start",

        screenshots: [
          {
            src: "mix-max/assets/screnshots/suggested_run.png",
            alt: "Screenshot of creating an experiment and its parameters",
          },
        ],
      },
    ],
    contentRight: [
      {
        type: "text/title_subtitle",

        horizontalAlign: "start",

        titles: ["Set Your Goal"],
        subtitles: [
          "Pick what you want to improve, then list the things you can change to make it happen.",
        ],
      },
      {
        type: "text/title_subtitle",

        horizontalAlign: "start",

        titles: ["Get a Smart Suggestion"],
        subtitles: [
          "No more guessing. Mix Max tells you exactly what to try next to reach your best result faster.",
        ],
      },
    ],
  },
];

const shared_feature_descriptions = [
  {
    type: "layout/split_horizontal",
    contentRight: [
      {
        type: "screenshot/single_enlarged",

        horizontalAlign: "start",
        screenshotSide: "right",

        screenshots: [
          {
            src: "mix-max/assets/screnshots/best_run_details.png",
            alt: "Screenshot of logged results and the best combination",
          },
        ],
      },
    ],
    contentLeft: [
      {
        type: "text/title_subtitle",

        textStyle: {
          textAlign: "end",
        },

        titles: ["Track Your Experiments"],
        subtitles: [
          "Write down how each try turned out. The more you log, the smarter Mix Max gets.",
        ],
      },
      {
        type: "text/title_subtitle",

        textStyle: {
          textAlign: "end",
        },

        titles: ["See What Works Best"],
        subtitles: [
          "Mix Max shows you the winning combination, so you always know the best version of what you're making.",
        ],
      },
    ],
  },
];

const mobile_main_feature_descriptions = cloneDeep(main_feature_descriptions);
mobile_main_feature_descriptions[0].contentLeft[0].containerStyle = {
  justifyContent: "end",
};

const mobile_shared_feature_descriptions = cloneDeep(shared_feature_descriptions);
mobile_shared_feature_descriptions[0].contentRight[0].containerStyle = {
  justifyContent: "start",
};

export const mix_max_config = {
  name: "Mix Max",
  subtitles,
  backgroundColor: "#E6BC55",

  //Vanta
  highlightColor: "#F7DD8E",
  midtoneColor: "#EFCB6E",
  lowlightColor: "#CFA23E",
  baseColor: "#E6BC55",

  path: "/mix-max",

  title: "Mix Max: Find the Best Combination with Bayesian Optimization",
  description:
    "Stop guessing, start optimizing. Mix Max uses Bayesian optimization to mathematically find the best combination of variables, whether you're perfecting a cocktail recipe or fine-tuning a complex process.",
  keywords:
    "Bayesian Optimization App, Experiment Optimization, Find Best Parameters, Cocktail Recipe Optimizer, Process Optimization, Optimize Variables, Mix Max",

  googlePlayLink: "https://play.google.com/store/apps/details?id=app.myfortuna.mix_max",
  appStoreLink: "https://apps.apple.com/us/app/mix-max-experiment-improve/id6780392674",

  sections: [
    {
      type: "layout/split_horizontal",
      leftFlex: 4,
      rightFlex: 6,
      contentLeft: [...introduction],
      contentRight: [...introduction_showcase],
    },
    ...main_feature_descriptions,
    ...shared_feature_descriptions,
  ],
  mobileSections: [
    ...introduction,
    ...introduction_showcase,
    ...mobile_main_feature_descriptions,
    ...mobile_shared_feature_descriptions,
  ],
};
